import { CASHBACK_ERROR_ROUTES } from "../cashbackFunding";
import {
  MappedPanelError,
  mapPanelError,
  PanelErrorRoute,
} from "../panelErrors";
import { TradeCorrectionFormValues } from "./types";

export type TradeCorrectionErrorField = keyof TradeCorrectionFormValues;

export type MappedTradeCorrectionError =
  MappedPanelError<TradeCorrectionErrorField>;

// Sibling of `holdingTradeActionErrors.ts`, not a reuse: this form has no `holding` field to blame anything on.
// Everything the ledger itself rejects falls to the panel banner along with anything unmatched.
const ROUTES: readonly PanelErrorRoute<TradeCorrectionErrorField>[] = [
  // Service-level guards.
  ["Trade correction would create a negative historical quantity", "quantity"],
  ["Trade would create a negative historical quantity", "quantity"],
  ["Trade quantity", "quantity"],
  ["Trade amount", "amountEur"],
  // DTO constraint messages, matched on their field prefix.
  ["Quantity ", "quantity"],
  ["Amount ", "amountEur"],
  ["Fee ", "feeEur"],
  ...CASHBACK_ERROR_ROUTES,
  ["Tax ", "taxWithheld"],
  ["Direction ", "direction"],
  ["This entry type does not accept a direction", "direction"],
  ["Trade date", "date"],
  ["Effective date ", "date"],
];

export const mapTradeCorrectionError = (
  messages: string[],
): MappedTradeCorrectionError => mapPanelError(messages, ROUTES);
